import { inject } from '@angular/core';
import { ListagemCarretaComponent } from './pages/(MotoristaExterno)/cadastro-frota/carreta/listagem-carreta/listagem-carreta.component';
import { appGuard } from './services/auth.guard';
import { ListagemCavaloComponent } from './pages/(MotoristaExterno)/cadastro-frota/cavalo/listagem-cavalo/listagem-cavalo.component';
import { ListagemAgendamentoComponent } from './pages/(MotoristaExterno)/agendamento/listagem-agendamento/listagem-agendamento.component';
import { ListagemServicosComponent } from './pages/(MotoristaExterno)/servicos/listagem-servicos/listagem-servicos.component';
import { ListagemLaudosHigienizacaoComponent } from './pages/(MotoristaExterno)/laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroCavaloComponent } from './pages/(MotoristaExterno)/cadastro-frota/cavalo/cadastro-cavalo/cadastro-cavalo.component';
import { CadastroCarretaComponent } from './pages/(MotoristaExterno)/cadastro-frota/carreta/cadastro-carreta/cadastro-carreta.component';
import { CadastroAgendamentoComponent } from './pages/(MotoristaExterno)/agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { CadastroLaudoHigienizacaoComponent } from './pages/(MotoristaExterno)/laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { CadastroEntradaServicosComponent } from './pages/(MotoristaExterno)/servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { Routes } from '@angular/router';
import { CadastroUsuarioComponent } from './pages/(MotoristaExterno)/cadastro-usuario/cadastro-usuario.component';
import { TicketAgendamentoComponent } from './pages/(MotoristaExterno)/agendamento/ticket-agendamento/ticket-agendamento.component';
import { CadastroPagamentoAgendamentoComponent } from './pages/(MotoristaExterno)/agendamento/cadastro-pagamento-agendamento/cadastro-pagamento-agendamento.component';

export const motoristaRoutes: Routes = [
  {
    path: 'motorista-externo/cadastro-usuario',
    component: CadastroUsuarioComponent
  },
  {
    path: 'motorista-externo/ticket-agendamento',
    component: TicketAgendamentoComponent
  },
  {
    path: 'motorista-externo/pagamento',
    component: CadastroPagamentoAgendamentoComponent
  },
  {
    path: 'motorista-externo/listagem',
    children: [
      {
        path: 'carreta',
        component: ListagemCarretaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'cavalo',
        component: ListagemCavaloComponent,
        canActivate: [appGuard]
      },
      {
        path: 'agendamento',
        component: ListagemAgendamentoComponent,
        canActivate: [appGuard]
      },

      {
        path: 'servicos',
        component: ListagemServicosComponent,
        canActivate: [appGuard]
      },
      {
        path: 'laudos-higienizacao',
        component: ListagemLaudosHigienizacaoComponent,
        canActivate: [appGuard]
      }
    ]
  },
  {
    path: 'motorista-externo/cadastro',
    children: [
      {
        path: 'cavalo',
        component: CadastroCavaloComponent,
        canActivate: [appGuard]
      },
      {
        path: 'carreta',
        component: CadastroCarretaComponent,
        canActivate: [appGuard]
      },
      {
        path: 'agendamento',
        component: CadastroAgendamentoComponent,
        canActivate: [appGuard]
      },
      {
        path: 'laudo-higienizacao',
        component: CadastroLaudoHigienizacaoComponent,
        canActivate: [appGuard]
      },
      {
        path: 'servicos',
        component: CadastroEntradaServicosComponent,
        canActivate: [appGuard]
      }
    ]
  },
  {
    path: 'motorista-externo/edicao',
    children: [
      {
        path: 'cadastro',
        component: CadastroUsuarioComponent,
        canActivate: [appGuard]
      }
    ]
  }
];
